/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { reactSelectCustomStyleCms } from 'helper';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { InputTemplate } from 'modules/common/components/inputComponents';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';
import * as action from '../actions';
import * as c from '../constant';

function UpdateModal({
  updateList,
  updateTaxCredit,
  getTaxCreditList,
  showTaxCredit,
  history,
  updating,
  id,
}) {
  const [formData, setFormData] = useState({
    type: '',
    amount: updateList.amount || '',
  });
  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    type: 'required',
    amount: 'required|number',
    remarks: 'required_if:type=REDUCE',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();

    updateTaxCredit(id, formData, ({ data }) => {
      setModal({ isOpen: false });
      getTaxCreditList();
      showTaxCredit(data.id);
      history.push('/rpt/land/land-settings/tax-credit/');
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12">
            <InputTemplate
              isSelect
              title="Transaction Type"
              labelClassName="form-label"
              htmlFor="type"
              containerClassName=""
              formValidatorMsg={validateForm.renderMessage('type')}
              // Input component props
              placeholder="Type"
              styles={reactSelectCustomStyleCms()}
              // className="full-input text-uppercase"
              className="full-input"
              id="type"
              name="type"
              type="input"
              options={c.TRANSACTION_TYPE}
              onChange={handleOnChangeSelect('type')}
              value={
                c.TRANSACTION_TYPE.find(
                  (item) => _.get(formData, 'type') === _.get(item, 'value')
                ) || ''
              }
              components={{ IndicatorSeparator: () => null }}
            />
          </div>
          <div className="col-12">
            <InputTemplate
              title="Amount"
              labelClassName="form-label"
              formValidatorMsg={validateForm.renderMessage('amount')}
              withCustomInputComponent={() => (
                <NumberFormat
                  name="amount"
                  id="amount"
                  placeholder="PHP 0.00"
                  className="form-control"
                  onValueChange={(values) => {
                    const { floatValue } = values;
                    setFormData(() => ({
                      ...formData,
                      amount: floatValue >= 0 ? floatValue : '',
                    }));
                  }}
                  isNumericString
                  thousandSeparator
                  allowNegative
                  allowLeadingZeros
                  displayType="input"
                  prefix="PHP "
                  value={_.get(formData, 'amount')?.toString()}
                />
              )}
            />
          </div>
          <div className="col-12">
            <InputTemplate
              title="Remarks"
              labelClassName="form-label"
              formValidatorMsg={validateForm.renderMessage('remarks')}
              withCustomInputComponent={() => (
                <textarea
                  className="form-control"
                  rows="3"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      remarks: e.target.value,
                    })
                  }
                  value={_.get(formData, 'remarks') || ''}
                  style={{ resize: 'none' }}
                />
              )}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateTaxCredit: PropTypes.instanceOf(Function).isRequired,
  getTaxCreditList: PropTypes.instanceOf(Function).isRequired,
  showTaxCredit: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_TAX_CREDIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
